import { ICssShadow } from './../ICssShadow.interface';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';
import { Video } from '../../../../../shared/sdk/index';

export class SeVideoYoutubeConfig extends SeCommonConfig implements IBaseSEConfig {

  // settings just for this element
  public SeType = 'SeVideoYoutube';
  public modelRef: Video;

  public mute: boolean;
  public isYoutubeVideo = true;
  public youtubeId: string;

  public playList: Array<string> = new Array();

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.isYoutubeVideo = this.isYoutubeVideo;
    obj.youtubeId = this.youtubeId;
    obj.SeType = this.SeType;
    obj.mute = this.mute;
    obj.modelRef = this.modelRef;
    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.mute = _.get(obj, 'mute', null);
    this.isYoutubeVideo = _.get(obj, 'isYoutubeVideo', false);
    this.youtubeId = _.get(obj, 'youtubeId', '');
    this.modelRef = _.get(obj, 'modelRef', null);

    // override some props that werer filled in by super call
    this.sizeInBytes = _.get(obj, 'modelRef.FileSize', 0);

    if (this.modelRef) {
      this.files = [];
      this.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.ProcessedFilename,
        hash: this.modelRef.hash
      });
    }

  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-video-youtube/se-video-youtube-config.class.ts